var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { createRoot } from "react-dom/client";
import { FacetecApp } from "./app/react-ts-sample";
import { ProgressStepper, ENROLL_STEPS, VERIFICATION_STEPS } from "./components/ProgressStepper";
import { Config } from "./Config";
var container = document.getElementById("app");
var root = createRoot(container);
var BasicComponent = /** @class */ (function (_super) {
    __extends(BasicComponent, _super);
    function BasicComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showModal: false,
            modalType: null,
            showStepper: false,
            currentStep: 1,
            steps: []
        };
        _this.sdkInitTimeoutId = null;
        _this.sdkDidInitialize = false;
        _this.originalFetch = null;
        _this.sessionId = '';
        _this.sessionCloseLogged = false;
        _this.sessionStartedAt = 0;
        _this.sessionExpectedCloseReason = null;
        _this.sessionExpectedCloseExtra = {};
        _this.retryDetectionLastEmittedAt = 0;
        _this.retryDetectionCount = 0;
        _this.handleStartSession = function () {
            _this.setState({ showModal: false });
            if (_this.state.modalType === 'verification') {
                _this.onLivenessCheckPressed();
            }
            else if (_this.state.modalType === 'enroll') {
                _this.onEnrollUserPressed();
            }
        };
        _this.handleCancelSession = function () {
            _this.setState({ showModal: false, modalType: null });
        };
        return _this;
    }
    BasicComponent.prototype.onLivenessCheckPressed = function () {
        FacetecApp.onLivenessCheckPressed();
    };
    BasicComponent.prototype.onEnrollUserPressed = function () {
        FacetecApp.onEnrollUserPressed();
    };
    // ZIYU-12573: prueba de vida (liveness-only) para el pre-registro web
    BasicComponent.prototype.onLivenessOnlyPressed = function () {
        FacetecApp.onLivenessOnlyPressed();
    };
    BasicComponent.prototype.generarSessionId = function () {
        try {
            var cryptoObj = window.crypto;
            if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
                return cryptoObj.randomUUID();
            }
            if (cryptoObj && typeof cryptoObj.getRandomValues === 'function') {
                // UUID v4 compliant usando getRandomValues
                var bytes = new Uint8Array(16);
                cryptoObj.getRandomValues(bytes);
                bytes[6] = (bytes[6] & 0x0f) | 0x40; // versión 4
                bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
                var hex = [];
                for (var i = 0; i < 16; i++) {
                    hex.push(bytes[i].toString(16).padStart(2, '0'));
                }
                return "".concat(hex.slice(0, 4).join(''), "-").concat(hex.slice(4, 6).join(''), "-").concat(hex.slice(6, 8).join(''), "-").concat(hex.slice(8, 10).join(''), "-").concat(hex.slice(10, 16).join(''));
            }
        }
        catch (e) {
            console.warn('⚠️ [SessionId] crypto no disponible, usando fallback Math.random:', e);
        }
        // Fallback final (menos seguro, pero útil para WebViews muy viejos)
        var rand = function () { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); };
        return "".concat(rand()).concat(rand(), "-").concat(rand(), "-4").concat(rand().substr(0, 3), "-").concat(rand(), "-").concat(rand()).concat(rand()).concat(rand());
    };
    BasicComponent.prototype.componentDidMount = function () {
        var _this = this;
        this.sessionId = this.generarSessionId();
        window.__sessionId = this.sessionId;
        window.getSessionId = function () { return _this.sessionId; };
        console.log("\uD83D\uDD16 [SessionId] ".concat(this.sessionId));
        this.sessionStartedAt = Date.now();
        this.instalarCapturaDeErrores();
        this.instalarInterceptorFetch();
        this.instalarInterceptorXHR();
        this.instalarCapturaDeSalida();
        this.instalarObservadorPantallaDeRetry();
        window.enviarLog = function (event, extra) { return _this.enviarLog(event, extra); };
        window.markSessionClosedExpected = function (reason, extra) {
            return _this.markSessionClosedExpected(reason, extra);
        };
        this.ejecutarAccionSegunRuta();
        window.updateStepperProgress = function (step) {
            _this.setState({ currentStep: step });
        };
        window.showStepper = function (type) {
            _this.setState({
                showStepper: true,
                currentStep: 1,
                steps: type === 'enroll' ? ENROLL_STEPS : VERIFICATION_STEPS
            });
        };
        window.hideStepper = function () {
            _this.setState({ showStepper: false });
        };
    };
    BasicComponent.prototype.serializarError = function (err) {
        if (!err)
            return { message: String(err) };
        if (err instanceof Error) {
            return {
                name: err.name,
                message: err.message,
                stack: err.stack
            };
        }
        if (typeof err === 'object') {
            try {
                return JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err)));
            }
            catch (_a) {
                return { message: String(err) };
            }
        }
        return { message: String(err) };
    };
    BasicComponent.prototype.instalarCapturaDeErrores = function () {
        var _this = this;
        window.addEventListener('error', function (ev) {
            _this.enviarLog('window_error', {
                level: 'error',
                message: ev.message,
                filename: ev.filename,
                lineno: ev.lineno,
                colno: ev.colno,
                error: _this.serializarError(ev.error)
            });
        });
        window.addEventListener('unhandledrejection', function (ev) {
            _this.enviarLog('unhandled_rejection', {
                level: 'error',
                reason: _this.serializarError(ev.reason)
            });
        });
    };
    /**
     * Marca que el cierre de la WebView que viene a continuación es ESPERADO
     * (por ejemplo, porque FaceTec completó y Flutter va a cerrar la vista).
     * Esto evita que el próximo pagehide/beforeunload se reporte como cierre
     * inesperado del usuario.
     */
    BasicComponent.prototype.markSessionClosedExpected = function (reason, extra) {
        if (extra === void 0) { extra = {}; }
        this.sessionExpectedCloseReason = reason;
        this.sessionExpectedCloseExtra = extra || {};
        console.log("\uD83D\uDD16 [SessionClose] Marcado cierre esperado: ".concat(reason));
    };
    BasicComponent.prototype.logSessionClose = function (rawReason, extra) {
        if (extra === void 0) { extra = {}; }
        if (this.sessionCloseLogged)
            return;
        this.sessionCloseLogged = true;
        var sessionDurationMs = this.sessionStartedAt > 0 ? Date.now() - this.sessionStartedAt : 0;
        var esEsperado = this.sessionExpectedCloseReason !== null;
        var event = esEsperado ? 'session_closed_expected' : 'session_closed_unexpected';
        var level = esEsperado ? 'info' : 'error';
        this.enviarLog(event, __assign(__assign({ level: level, unloadEvent: rawReason, expectedReason: this.sessionExpectedCloseReason || null, sessionDurationMs: sessionDurationMs, visibilityState: typeof document !== 'undefined' ? document.visibilityState : undefined }, this.sessionExpectedCloseExtra), extra));
    };
    BasicComponent.prototype.instalarCapturaDeSalida = function () {
        var _this = this;
        // pagehide: funciona en iOS/Safari donde beforeunload no. También dispara cuando
        // el WebView se destruye o la app se cierra.
        window.addEventListener('pagehide', function (ev) {
            _this.logSessionClose(ev.persisted ? 'pagehide_persisted' : 'pagehide');
        });
        // beforeunload: cierre de pestaña / navegación fuera (navegadores de escritorio).
        window.addEventListener('beforeunload', function () {
            _this.logSessionClose('beforeunload');
        });
        // popstate: botón "volver atrás" del navegador/WebView cuando hay historial.
        window.addEventListener('popstate', function () {
            _this.enviarLog('user_navigated_back', {
                level: 'error',
                targetUrl: window.location.href
            });
        });
        // visibilitychange: cuando el usuario minimiza la app o cambia de pestaña.
        // Útil en WebViews: cuando Flutter tapa la webview o el usuario va al home del teléfono.
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'hidden') {
                _this.enviarLog('visibility_hidden', { level: 'info' });
            }
            else if (document.visibilityState === 'visible') {
                _this.enviarLog('visibility_visible', { level: 'info' });
            }
        });
    };
    /**
     * Decide si una URL debe trackearse para logging de red.
     * Cubre el middleware FaceTec y el backend ZiYU; descarta dominios externos
     * (CDNs, S3, etc.) para evitar ruido y rate-limit innecesario.
     */
    BasicComponent.prototype.esUrlTrackeable = function (url) {
        var backendBase = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT;
        var ziyuBase = Config.ZIYU_API_ENDPOINT;
        return url.startsWith(backendBase) || url.startsWith(ziyuBase);
    };
    BasicComponent.prototype.instalarInterceptorFetch = function () {
        var _this = this;
        var backendBase = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT;
        var logPath = "".concat(backendBase, "/log");
        this.originalFetch = window.fetch.bind(window);
        var enviarLog = this.enviarLog.bind(this);
        var serializarError = this.serializarError.bind(this);
        var esTrackeable = this.esUrlTrackeable.bind(this);
        var originalFetch = this.originalFetch;
        window.fetch = function (input, init) { return __awaiter(_this, void 0, void 0, function () {
            var url, method, startedAt, esLlamadaDeLog, response, durationMs, err_1, durationMs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = typeof input === 'string' ? input : (input instanceof URL ? input.toString() : input.url);
                        method = ((init === null || init === void 0 ? void 0 : init.method) || (typeof input !== 'string' && !(input instanceof URL) ? input.method : 'GET') || 'GET').toUpperCase();
                        startedAt = performance.now();
                        esLlamadaDeLog = url.startsWith(logPath);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, originalFetch(input, init)];
                    case 2:
                        response = _a.sent();
                        durationMs = Math.round(performance.now() - startedAt);
                        if (!esLlamadaDeLog && esTrackeable(url) && !response.ok) {
                            enviarLog('api_http_error', {
                                level: 'error',
                                transport: 'fetch',
                                url: url,
                                method: method,
                                status: response.status,
                                statusText: response.statusText,
                                durationMs: durationMs
                            });
                        }
                        return [2 /*return*/, response];
                    case 3:
                        err_1 = _a.sent();
                        durationMs = Math.round(performance.now() - startedAt);
                        if (!esLlamadaDeLog && esTrackeable(url)) {
                            enviarLog('api_network_error', {
                                level: 'error',
                                transport: 'fetch',
                                url: url,
                                method: method,
                                durationMs: durationMs,
                                error: serializarError(err_1)
                            });
                        }
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    /**
     * Parchea XMLHttpRequest para loguear todas las llamadas a backends conocidos.
     * Necesario porque el SDK de FaceTec (SessionRequestProcessor / MigrationProcessor)
     * usa XHR directamente, así que el interceptor de fetch no las captura.
     *
     * Solo añade listeners (no modifica argumentos ni consume eventos), así que
     * coexiste con el código del SDK sin afectar su comportamiento.
     */
    BasicComponent.prototype.instalarInterceptorXHR = function () {
        var backendBase = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT;
        var logPath = "".concat(backendBase, "/log");
        var enviarLog = this.enviarLog.bind(this);
        var esTrackeable = this.esUrlTrackeable.bind(this);
        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function (method, url) {
            var rest = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                rest[_i - 2] = arguments[_i];
            }
            var urlStr = typeof url === 'string' ? url : url.toString();
            this.__logMeta = {
                method: (method || 'GET').toUpperCase(),
                url: urlStr,
                startedAt: 0,
                logged: false
            };
            return originalOpen.call.apply(originalOpen, __spreadArray([this, method, url], rest, false));
        };
        XMLHttpRequest.prototype.send = function (body) {
            var _this = this;
            var meta = this.__logMeta;
            if (meta) {
                meta.startedAt = performance.now();
                var esLlamadaDeLog = meta.url.startsWith(logPath);
                if (!esLlamadaDeLog && esTrackeable(meta.url)) {
                    // loadend cubre load + error + abort + timeout en un único punto.
                    this.addEventListener('loadend', function () {
                        if (meta.logged)
                            return;
                        meta.logged = true;
                        var durationMs = Math.round(performance.now() - meta.startedAt);
                        // status === 0 ⇒ error de red, abort o timeout (no llegó respuesta).
                        if (_this.status === 0) {
                            enviarLog('api_network_error', {
                                level: 'error',
                                transport: 'xhr',
                                url: meta.url,
                                method: meta.method,
                                durationMs: durationMs
                            });
                            return;
                        }
                        if (_this.status >= 400) {
                            enviarLog('api_http_error', {
                                level: 'error',
                                transport: 'xhr',
                                url: meta.url,
                                method: meta.method,
                                status: _this.status,
                                statusText: _this.statusText,
                                durationMs: durationMs
                            });
                        }
                    });
                }
            }
            return originalSend.call(this, body);
        };
    };
    /**
     * Instala un MutationObserver que detecta cuando el SDK FaceTec muestra su
     * pantalla de retry interna (la que aparece tras una captura de mala calidad).
     *
     * A diferencia de la heurística por tamaño de blob (que infiere el retry tras
     * el hecho), esta detección es del momento exacto en que el SDK le pide al
     * usuario una nueva foto, e incluye la razón específica (rostro no visible,
     * iluminación baja, reflejo en el documento, etc.).
     *
     * Tiene cooldown para no duplicar logs durante las animaciones de la pantalla.
     */
    BasicComponent.prototype.instalarObservadorPantallaDeRetry = function () {
        var _this = this;
        var enviarLog = this.enviarLog.bind(this);
        var detectarEnNodo = function (root) {
            if (!root)
                return;
            var text = root.textContent;
            if (!text || text.length === 0)
                return;
            var headerHit = BasicComponent.SDK_RETRY_HEADER_PHRASES.find(function (p) { return text.indexOf(p) !== -1; });
            if (!headerHit)
                return;
            var now = Date.now();
            if (now - _this.retryDetectionLastEmittedAt < BasicComponent.RETRY_DETECTION_COOLDOWN_MS) {
                return;
            }
            _this.retryDetectionLastEmittedAt = now;
            _this.retryDetectionCount++;
            try {
                window.__sdkRetryScreenCount = (window.__sdkRetryScreenCount || 0) + 1;
            }
            catch ( /* noop */_a) { /* noop */ }
            // Buscar razones sobre TODA la pantalla, no solo el nodo que mutó: el header
            // y la razón suelen vivir en nodos/mutaciones distintos, así que inspeccionar
            // solo `text` (el nodo mutado) hacía que se perdiera el motivo.
            var fullText = document.body.textContent || text;
            // Recoger todas las razones específicas (estándares/documento) presentes.
            var detectedReasons = [];
            BasicComponent.SDK_RETRY_REASON_MAP.forEach(function (_a) {
                var phrase = _a.phrase, reason = _a.reason;
                if (fullText.indexOf(phrase) !== -1)
                    detectedReasons.push(reason);
            });
            // Retry de selfie: el SDK solo muestra tips genéricos, sin motivo diagnóstico.
            var isGenericSelfieRetry = detectedReasons.length === 0 &&
                BasicComponent.SDK_RETRY_GENERIC_SELFIE_TIPS.some(function (tip) { return fullText.indexOf(tip) !== -1; });
            var primaryReason = detectedReasons[0] ||
                (isGenericSelfieRetry ? 'facescan_generic_quality' : 'unspecified');
            var retryScreenType = detectedReasons.length
                ? 'diagnosed'
                : (isGenericSelfieRetry ? 'facescan' : 'unknown');
            // Texto legible que muestra el SDK bajo "Intentemos Nuevamente" (subheader +
            // motivos/instrucciones). Es la "razón" humana que ve el usuario en pantalla.
            var reasonText = _this.extraerTextoLegibleDeRetry();
            enviarLog('sdk_retry_screen_shown', {
                level: 'info',
                triggerFlow: window.__currentTriggerFlow || '',
                retryDetectionCount: _this.retryDetectionCount,
                detectedReasons: detectedReasons,
                reasonCount: detectedReasons.length,
                primaryReason: primaryReason,
                reasonText: reasonText,
                retryScreenType: retryScreenType
            });
            // Capturar (best-effort) la selfie rechazada que el SDK muestra en "Su Selfie".
            if (BasicComponent.ENABLE_RETRY_SELFIE_CAPTURE) {
                _this.capturarYLoguearSelfieDeRetry(primaryReason);
            }
        };
        try {
            var observer = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    var m = mutations[i];
                    if (m.type === 'characterData') {
                        detectarEnNodo(m.target);
                    }
                    else if (m.type === 'childList') {
                        m.addedNodes.forEach(detectarEnNodo);
                    }
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
        catch (e) {
            console.warn('⚠️ [RetryObserver] No se pudo instalar:', e);
        }
    };
    /**
     * Intenta extraer la imagen "Su Selfie" (la captura rechazada) que el SDK muestra
     * en la pantalla de retry, la reduce de tamaño y la emite en un log APARTE
     * ('sdk_retry_selfie_capture') para no inflar el evento principal ni exceder el
     * límite de sendBeacon.
     *
     * Best-effort: el DOM interno del SDK puede cambiar entre versiones; si la imagen
     * no se encuentra o no se puede serializar (canvas/imagen "tainted" por CORS), se
     * registra el motivo del fallo pero no se rompe el flujo.
     */
    /**
     * Devuelve el texto legible que el SDK muestra en la pantalla de retry para
     * explicarle al usuario por qué se pidió otra foto (p. ej. "Necesitamos una Foto
     * Más Clara" y, si aplica, motivos específicos o instrucciones). Es la "razón"
     * humana, a diferencia de `primaryReason` que es machine-readable.
     */
    BasicComponent.prototype.extraerTextoLegibleDeRetry = function () {
        var fullText = document.body.textContent || '';
        var parts = [];
        // 1) Subheader explicativo principal (lo que sale bajo "Intentemos Nuevamente").
        BasicComponent.SDK_RETRY_HEADER_PHRASES.forEach(function (p) {
            if (fullText.indexOf(p) !== -1)
                parts.push(p);
        });
        // 2) Motivos específicos (documento/estándares), si están presentes.
        BasicComponent.SDK_RETRY_REASON_MAP.forEach(function (_a) {
            var phrase = _a.phrase;
            if (fullText.indexOf(phrase) !== -1)
                parts.push(phrase);
        });
        // 3) Instrucciones/tips visibles del retry de selfie.
        BasicComponent.SDK_RETRY_GENERIC_SELFIE_TIPS.forEach(function (tip) {
            if (fullText.indexOf(tip) !== -1)
                parts.push(tip);
        });
        // Deduplicar preservando el orden.
        var uniq = parts.filter(function (p, i) { return parts.indexOf(p) === i; });
        return uniq.join(' · ');
    };
    BasicComponent.prototype.capturarYLoguearSelfieDeRetry = function (primaryReason) {
        var _this = this;
        // La tarjeta de retry (y sus imágenes) se dibujan unos ms DESPUÉS de que aparece
        // el texto del header. Reintentamos con delays crecientes hasta que las miniaturas
        // se dimensionen (tamaño > 0) y podamos capturar la selfie.
        var delays = [400, 400, 500, 700, 900]; // ~2.9s en total
        var attempt = 0;
        var intentar = function () {
            attempt++;
            try {
                var _a = _this.buscarMediaDeSelfieRetry(), media_1 = _a.media, diag_1 = _a.diag;
                if (!media_1) {
                    if (attempt < delays.length) {
                        setTimeout(intentar, delays[attempt]);
                        return;
                    }
                    _this.enviarLog('sdk_retry_selfie_capture', __assign({ level: 'info', captured: false, failReason: 'media_not_found', primaryReason: primaryReason, attempts: attempt }, diag_1));
                    return;
                }
                _this.elementoADataUrl(media_1, 240, 0.6).then(function (dataUrl) {
                    if (!dataUrl) {
                        if (attempt < delays.length) {
                            setTimeout(intentar, delays[attempt]);
                            return;
                        }
                        _this.enviarLog('sdk_retry_selfie_capture', __assign({ level: 'info', captured: false, failReason: 'serialize_failed', mediaTag: media_1.tagName, primaryReason: primaryReason, attempts: attempt }, diag_1));
                        return;
                    }
                    _this.enviarLog('sdk_retry_selfie_capture', __assign({ level: 'info', captured: true, primaryReason: primaryReason, mediaTag: media_1.tagName, imageDataUrl: dataUrl, approxBytes: dataUrl.length, attempts: attempt }, diag_1));
                });
            }
            catch (e) {
                _this.enviarLog('sdk_retry_selfie_capture', {
                    level: 'warn', captured: false, failReason: 'exception', message: String(e)
                });
            }
        };
        setTimeout(intentar, delays[0]);
    };
    /**
     * Localiza la imagen "Su Selfie" (la captura del usuario) mediante geometría:
     * ubica el label "Su Selfie" y elige la imagen que está justo ENCIMA y alineada
     * horizontalmente con él. Así se evita capturar el logo/marca de agua de FaceTec
     * o la imagen de "Pose Ideal". Considera <canvas>, <img> y elementos con
     * background-image. Devuelve además diagnóstico de los candidatos hallados.
     */
    BasicComponent.prototype.buscarMediaDeSelfieRetry = function () {
        var _this = this;
        var label = BasicComponent.SDK_RETRY_YOUR_IMAGE_LABEL;
        var idealLabel = BasicComponent.SDK_RETRY_IDEAL_IMAGE_LABEL;
        // FaceTec pre-renderiza TODAS las pantallas helper ocultas (tamaño 0) en el DOM.
        // Por eso solo consideramos elementos VISIBLES: así apuntamos a la pantalla de
        // retry real y no a una copia oculta.
        var esVisible = function (el) {
            var r = el.getBoundingClientRect();
            return r.width > 0 && r.height > 0;
        };
        // Elemento visible más profundo (último en orden de documento) que contiene un texto.
        var deepestConTexto = function (txt) {
            var found = null;
            var nodes = document.body.querySelectorAll('*');
            for (var i = 0; i < nodes.length; i++) {
                if ((nodes[i].textContent || '').indexOf(txt) !== -1 && esVisible(nodes[i])) {
                    found = nodes[i];
                }
            }
            return found;
        };
        var labelEl = deepestConTexto(label);
        var idealEl = deepestConTexto(idealLabel);
        // Ancestro común de los LABELS "Su Selfie" y "Pose Ideal". Ojo: suele ser la
        // FILA DE TEXTOS, que no incluye las miniaturas (están en una fila hermana
        // arriba). Por eso luego subimos de nivel hasta encontrar las imágenes.
        var labelsAncestor = null;
        if (labelEl && idealEl) {
            var n = labelEl;
            for (var up = 0; up < 10 && n; up++) {
                if (n.contains(idealEl)) {
                    labelsAncestor = n;
                    break;
                }
                n = n.parentElement;
            }
        }
        if (!labelsAncestor && labelEl)
            labelsAncestor = labelEl.parentElement;
        var recolectar = function (scope) {
            var out = [];
            var scan = scope.querySelectorAll('*');
            var pool = [scope];
            for (var i = 0; i < scan.length; i++)
                pool.push(scan[i]);
            for (var i = 0; i < pool.length; i++) {
                var el = pool[i];
                var tag = el.tagName;
                var isCanvasOrImg = tag === 'CANVAS' || tag === 'IMG';
                var bg = false;
                if (!isCanvasOrImg) {
                    var cbg = getComputedStyle(el).backgroundImage || '';
                    bg = /url\(/i.test(cbg) && cbg !== 'none';
                    if (!bg)
                        continue;
                }
                var r = el.getBoundingClientRect();
                if (r.width < 40 || r.height < 40)
                    continue; // descartar iconos/marcas pequeñas
                // Descartar branding conocido por su url (logo, marca de agua, etc.).
                var url = _this.getSrcOBgUrl(el) || '';
                if (/logo|watermark|branding|facetec/i.test(url))
                    continue;
                out.push({ el: el, r: r, tag: tag, bg: bg, aspect: r.width / r.height });
            }
            return out;
        };
        // Subir de nivel desde la fila de labels hasta encontrar candidatos (las
        // miniaturas). Se detiene en cuanto un scope tiene al menos un candidato.
        var scope = labelsAncestor || document.body;
        var candidates = recolectar(scope);
        for (var up = 0; up < 4 && candidates.length === 0 && scope.parentElement; up++) {
            scope = scope.parentElement;
            candidates = recolectar(scope);
        }
        var chosen = null;
        // 1) Preferencia geométrica: imagen directamente ENCIMA del label "Su Selfie".
        if (labelEl) {
            var lr = labelEl.getBoundingClientRect();
            var lcx = lr.left + lr.width / 2;
            var bestScore = Infinity;
            for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
                var c = candidates_1[_i];
                var ccx = c.r.left + c.r.width / 2;
                if (c.r.bottom > lr.top + 8)
                    continue; // debe estar por encima del label
                if (Math.abs(ccx - lcx) > c.r.width)
                    continue; // alineada horizontalmente con el label
                var score = (lr.top - c.r.bottom) + Math.abs(ccx - lcx);
                if (score < bestScore) {
                    bestScore = score;
                    chosen = c;
                }
            }
        }
        // 2) Fallback: de dos imágenes lado a lado, "Su Selfie" es la de la IZQUIERDA.
        if (!chosen && candidates.length) {
            var portraitish = candidates.filter(function (c) { return c.aspect <= 1.3; });
            var pool = (portraitish.length ? portraitish : candidates).slice();
            pool.sort(function (a, b) { return a.r.left - b.r.left; });
            chosen = pool[0];
        }
        // Diagnóstico mínimo (útil para depurar si algún día cambia el DOM del SDK,
        // sin engordar el log con dumps completos).
        var diag = {
            labelFound: !!labelEl,
            candidateCount: candidates.length,
            chosen: chosen ? {
                tag: chosen.tag, bg: chosen.bg,
                w: Math.round(chosen.r.width), h: Math.round(chosen.r.height), x: Math.round(chosen.r.left)
            } : null
        };
        return { media: chosen ? chosen.el : null, diag: diag };
    };
    /** Devuelve la URL de origen de un <img> o el data/blob/url de un background-image. */
    BasicComponent.prototype.getSrcOBgUrl = function (el) {
        if (el instanceof HTMLImageElement) {
            return el.currentSrc || el.src || null;
        }
        var bg = (el.style.backgroundImage || getComputedStyle(el).backgroundImage || '');
        var m = bg.match(/url\((["']?)(.*?)\1\)/i);
        return m && m[2] ? m[2] : null;
    };
    /**
     * Redibuja un canvas/img/elemento-con-background a `maxSize` y lo serializa a JPEG.
     * Es asíncrono porque un background-image (o un <img> aún no cargado) necesita
     * cargarse antes de poder dibujarse. Resuelve null si no hay dimensiones o si
     * toDataURL lanza (canvas "tainted" por contenido cross-origin).
     */
    BasicComponent.prototype.elementoADataUrl = function (el, maxSize, quality) {
        var _this = this;
        return new Promise(function (resolve) {
            var draw = function (src, sw, sh) {
                try {
                    if (!sw || !sh) {
                        resolve(null);
                        return;
                    }
                    var scale = Math.min(1, maxSize / Math.max(sw, sh));
                    var dw = Math.max(1, Math.round(sw * scale));
                    var dh = Math.max(1, Math.round(sh * scale));
                    var off = document.createElement('canvas');
                    off.width = dw;
                    off.height = dh;
                    var ctx = off.getContext('2d');
                    if (!ctx) {
                        resolve(null);
                        return;
                    }
                    ctx.drawImage(src, 0, 0, dw, dh);
                    resolve(off.toDataURL('image/jpeg', quality));
                }
                catch (e) {
                    resolve(null);
                }
            };
            try {
                if (el instanceof HTMLCanvasElement) {
                    draw(el, el.width, el.height);
                    return;
                }
                if (el instanceof HTMLImageElement && el.complete && (el.naturalWidth || el.width)) {
                    draw(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
                    return;
                }
                // background-image o <img> aún no cargado: cargar vía Image y luego dibujar.
                var url = _this.getSrcOBgUrl(el);
                if (!url) {
                    resolve(null);
                    return;
                }
                var img_1 = new Image();
                img_1.crossOrigin = 'anonymous';
                img_1.onload = function () { return draw(img_1, img_1.naturalWidth, img_1.naturalHeight); };
                img_1.onerror = function () { return resolve(null); };
                img_1.src = url;
            }
            catch (e) {
                resolve(null);
            }
        });
    };
    BasicComponent.prototype.enviarLog = function (event, extra) {
        if (extra === void 0) { extra = {}; }
        try {
            var urlParams = new URLSearchParams(window.location.search);
            var userRut = urlParams.get('rut') || '';
            var queryParams_1 = {};
            urlParams.forEach(function (value, key) { queryParams_1[key] = value; });
            var payload = __assign({ sessionId: this.sessionId, userRut: userRut, event: event, level: (extra && extra.level) || 'info', route: window.location.pathname, normalizedRoute: window.location.pathname.replace(/\/+$/, "").toLowerCase(), fullUrl: window.location.href, referrer: document.referrer || '', userAgent: navigator.userAgent, language: navigator.language, platform: navigator.platform || '', screen: { width: window.screen.width, height: window.screen.height }, viewport: { width: window.innerWidth, height: window.innerHeight }, queryParams: queryParams_1, timestamp: new Date().toISOString() }, extra);
            var url = "".concat(Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT, "/log");
            var bodyStr = JSON.stringify(payload);
            var enviado = false;
            // Primero intentar sendBeacon: garantiza entrega aún si la página se está cerrando
            try {
                if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
                    var blob = new Blob([bodyStr], { type: 'application/json' });
                    enviado = navigator.sendBeacon(url, blob);
                }
            }
            catch (e) {
                enviado = false;
            }
            // Fallback: fetch con keepalive:true (también sobrevive al unload)
            if (!enviado) {
                var doFetch = this.originalFetch || window.fetch.bind(window);
                doFetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: bodyStr,
                    keepalive: true
                }).catch(function (err) { return console.error('❌ [Log] Error enviando log:', err); });
            }
            if (payload.level === 'error') {
                console.error("\uD83D\uDCDD [Log:error] ".concat(event), payload);
            }
            else {
                console.log("\uD83D\uDCDD [Log] ".concat(event), payload);
            }
        }
        catch (err) {
            console.error('❌ [Log] Error construyendo log:', err);
        }
    };
    BasicComponent.prototype.ejecutarAccionSegunRuta = function () {
        var _this = this;
        var rutaNormalizada = window.location.pathname.replace(/\/+$/, "").toLowerCase();
        var terminaCon = function (valor) {
            return rutaNormalizada.length >= valor.length && rutaNormalizada.lastIndexOf(valor) === (rutaNormalizada.length - valor.length);
        };
        // Verificar si viene parámetro auto=true para iniciar directamente
        var urlParams = new URLSearchParams(window.location.search);
        var autoStart = urlParams.get('auto') === 'true';
        // Permite ajustar delay vía URL: ?delay=2000 (ms)
        var delayMs = Math.max(0, parseInt(urlParams.get('delay') || '1200', 10)) || 1200;
        this.enviarLog('page_open', { autoStart: autoStart, delayMs: delayMs });
        // Timeout de seguridad: si el SDK no inicializa en 30s lo registramos como error
        var SDK_INIT_TIMEOUT_MS = 30000;
        this.sdkInitTimeoutId = window.setTimeout(function () {
            if (!_this.sdkDidInitialize) {
                _this.enviarLog('sdk_init_timeout', {
                    level: 'error',
                    timeoutMs: SDK_INIT_TIMEOUT_MS
                });
            }
        }, SDK_INIT_TIMEOUT_MS);
        var marcarSdkInicializado = function () {
            _this.sdkDidInitialize = true;
            if (_this.sdkInitTimeoutId !== null) {
                window.clearTimeout(_this.sdkInitTimeoutId);
                _this.sdkInitTimeoutId = null;
            }
        };
        if (terminaCon("/verification")) {
            this.enviarLog('route_matched', { triggerFlow: 'verification', autoStart: autoStart, delayMs: delayMs });
            FacetecApp.runAfterInitialization(function () {
                marcarSdkInicializado();
                _this.enviarLog('sdk_initialized', { triggerFlow: 'verification', autoStart: autoStart, delayMs: delayMs });
                if (autoStart) {
                    console.log("\u23F1\uFE0F [AutoStart] Iniciando verificaci\u00F3n en ".concat(delayMs, "ms"));
                    _this.enviarLog('auto_start_scheduled', { triggerFlow: 'verification', delayMs: delayMs });
                    setTimeout(function () {
                        _this.enviarLog('auto_start_fired', { triggerFlow: 'verification', delayMs: delayMs });
                        _this.onLivenessCheckPressed();
                    }, delayMs);
                }
                else {
                    // Mostrar modal (flujo anterior comentado para usar solo auto-inicio)
                    // this.setState({ showModal: true, modalType: 'verification' });
                    console.log('⚠️ Se requiere parámetro auto=true para iniciar');
                    _this.enviarLog('auto_start_missing_param', { triggerFlow: 'verification' });
                }
            });
            return;
        }
        if (terminaCon("/enroll")) {
            this.enviarLog('route_matched', { triggerFlow: 'enrollment', autoStart: autoStart, delayMs: delayMs });
            FacetecApp.runAfterInitialization(function () {
                marcarSdkInicializado();
                _this.enviarLog('sdk_initialized', { triggerFlow: 'enrollment', autoStart: autoStart, delayMs: delayMs });
                if (autoStart) {
                    console.log("\u23F1\uFE0F [AutoStart] Iniciando enrollment en ".concat(delayMs, "ms"));
                    _this.enviarLog('auto_start_scheduled', { triggerFlow: 'enrollment', delayMs: delayMs });
                    setTimeout(function () {
                        _this.enviarLog('auto_start_fired', { triggerFlow: 'enrollment', delayMs: delayMs });
                        _this.onEnrollUserPressed();
                    }, delayMs);
                }
                else {
                    // Mostrar modal (flujo anterior comentado para usar solo auto-inicio)
                    // this.setState({ showModal: true, modalType: 'enroll' });
                    console.log('⚠️ Se requiere parámetro auto=true para iniciar');
                    _this.enviarLog('auto_start_missing_param', { triggerFlow: 'enrollment' });
                }
            });
            return;
        }
        // ZIYU-12573: ruta liveness-only para el pre-registro web (aditiva, no toca enroll/verification)
        if (terminaCon("/liveness")) {
            this.enviarLog('route_matched', { triggerFlow: 'liveness', autoStart: autoStart, delayMs: delayMs });
            FacetecApp.runAfterInitialization(function () {
                marcarSdkInicializado();
                _this.enviarLog('sdk_initialized', { triggerFlow: 'liveness', autoStart: autoStart, delayMs: delayMs });
                if (autoStart) {
                    console.log("\u23F1\uFE0F [AutoStart] Iniciando liveness en ".concat(delayMs, "ms"));
                    _this.enviarLog('auto_start_scheduled', { triggerFlow: 'liveness', delayMs: delayMs });
                    setTimeout(function () {
                        _this.enviarLog('auto_start_fired', { triggerFlow: 'liveness', delayMs: delayMs });
                        _this.onLivenessOnlyPressed();
                    }, delayMs);
                }
                else {
                    console.log('⚠️ Se requiere parámetro auto=true para iniciar');
                    _this.enviarLog('auto_start_missing_param', { triggerFlow: 'liveness' });
                }
            });
            return;
        }
        // Ruta no reconocida: cancelar el watchdog del SDK (no aplica) y loguear como error
        if (this.sdkInitTimeoutId !== null) {
            window.clearTimeout(this.sdkInitTimeoutId);
            this.sdkInitTimeoutId = null;
        }
        this.enviarLog('route_not_matched', { level: 'error' });
    };
    BasicComponent.prototype.render = function () {
        var _a = this.state, showModal = _a.showModal, modalType = _a.modalType, showStepper = _a.showStepper, currentStep = _a.currentStep, steps = _a.steps;
        return (React.createElement("div", null,
            showStepper && (React.createElement(ProgressStepper, { currentStep: currentStep, steps: steps })),
            React.createElement("div", { className: "wrapping-box-container" },
                React.createElement("div", { id: "controls", className: "controls" },
                    React.createElement("p", { id: "status" }, "Initializing...")),
                React.createElement("div", { id: "custom-logo-container" },
                    React.createElement("img", { id: "facetec-logo", src: "../images/facetec_logo.png" })))));
    };
    // ===== Detector de pantalla de retry interna del SDK FaceTec =====
    // Frases que SOLO aparecen en la pantalla de retry del SDK (ver SpanishLocalization.ts).
    // El subheader "Necesitamos una Foto Más Clara" es el más distintivo y único
    // del flujo: si aparece en el DOM, el SDK acaba de rechazar la captura previa
    // por mala calidad y le está pidiendo al usuario otra foto.
    BasicComponent.SDK_RETRY_HEADER_PHRASES = [
        'Necesitamos una Foto Más Clara'
    ];
    // Mapeo de frases específicas → razón machine-readable para alertas/dashboards.
    // Estas frases corresponden a las claves "FaceTec_retry_*" del SpanishLocalization.
    BasicComponent.SDK_RETRY_REASON_MAP = [
        { phrase: 'Su Imagen No Cumplió con los Estándares', reason: 'image_did_not_meet_standards' },
        { phrase: 'Rostro No Completamente Visible', reason: 'face_not_fully_visible' },
        { phrase: 'Iluminación Demasiado Baja', reason: 'lighting_too_low' },
        { phrase: 'Iluminación Demasiado Extrema', reason: 'lighting_too_extreme' },
        { phrase: 'Documento No Completamente Visible', reason: 'id_not_fully_visible' },
        { phrase: 'Documento No Horizontal', reason: 'id_not_horizontal' },
        { phrase: 'Tipo de Documento No Soportado', reason: 'id_type_not_supported' },
        { phrase: 'Reflejo Detectado en el Documento', reason: 'id_glare_detected' },
        { phrase: 'Código de Barras No Leído', reason: 'id_barcode_not_read' }
    ];
    // Tips genéricos que FaceTec muestra en el retry de SELFIE. No son un motivo
    // diagnóstico: aparecen siempre iguales sin importar la causa real. Sirven para
    // clasificar el retry como 'facescan_generic_quality' en vez de 'unspecified'.
    BasicComponent.SDK_RETRY_GENERIC_SELFIE_TIPS = [
        'Sostener Cámara a la Altura de los Ojos',
        'Ilumine su Rostro Uniformemente',
        'Evite Sonreír y Contraluz',
        'Por favor use pose e iluminación ideal'
    ];
    // Labels bajo los que el SDK muestra la captura del usuario y la pose ideal.
    BasicComponent.SDK_RETRY_YOUR_IMAGE_LABEL = 'Su Selfie';
    BasicComponent.SDK_RETRY_IDEAL_IMAGE_LABEL = 'Pose Ideal';
    // ⚠️ PRIVACIDAD/BIOMETRÍA: capturar y almacenar la selfie rechazada implica
    // guardar datos biométricos del usuario. Activar solo con base legal y
    // consentimiento. Poner en false para desactivar por completo la captura.
    BasicComponent.ENABLE_RETRY_SELFIE_CAPTURE = true;
    BasicComponent.RETRY_DETECTION_COOLDOWN_MS = 1500;
    return BasicComponent;
}(React.Component));
export default BasicComponent;
root.render((React.createElement(BasicComponent, { tab: "home" })));
